<div style="padding: 20px;">
  <div style="display: flex; flex-direction: column; justify-content: left; align-items: center; margin-top: 10px;min-width: 90vw; min-height: 90vh;">
    <div style="position: absolute; top: 20px; right: 20px;" class="pi pi-times" (click)="onClose()"></div>
    @if (isImage) {
      <img [src]="url" style="max-width: 100%; max-height: 100%;" />
    }
    @if (isPdf) {
    }
  </div>
</div>
